export default __webpack_public_path__ + "static/media/help.30e6d95e.svg";